import { Stack, Table, TableContainer } from '@mui/material';
import { useSelector } from 'react-redux';

import EnchanedFilterTableHeader from './EnchanedFilterTableHeader';
import TableService from './TableService';
import NoDataFound from '../NoDataFound/NoDataFound';
import ActivityIndicator from './ActivityIndicator';

export default function Datatable({ onChangeFilter,sortChange, data, columns, isLoading, themeType, onClickRow, tableBodyBgColor, tableHeadBgColor, showCheckBox, onChangeCheckBox, onAllSelectCheckBox, isAllChecked  }) {
  return (
    <>
      <TableContainer>
        <Table stickyHeader className='!border-collapse table'>
          <EnchanedFilterTableHeader
            onChangeFilter={onChangeFilter}
            sortChange={sortChange}
            columns={columns}
            themeType={themeType}
            tableHeadBgColor={tableHeadBgColor}
            onSelectCheckBox={onAllSelectCheckBox}
            isChecked={isAllChecked}
          />
          <TableService
            rows={data}
            columns={columns}
            onClickRow={onClickRow}
            tableBodyBgColor={tableBodyBgColor}
            showCheckBox={showCheckBox}
            onChangeCheckBox={onChangeCheckBox}
          />
        </Table>
      </TableContainer>
      {data.length <= 0 && !isLoading && <NoDataFound />}
      {isLoading && <Stack sx={{overflow: 'hidden', marginTop: '10px'}}>
        <ActivityIndicator />
        </Stack>}
    </>
  );
}
